import { Component, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { map, Observable } from 'rxjs';
import { HkAbcPolicyAcksService } from './abc-policy-acks.service';
import { AsyncPipe, Location } from '@angular/common';
import { CustomPdfViewerComponent } from 'src/app/shared/custom-pdf-viewer.component';

@Component({
  selector: 'ad-hk-abc-policy-acks',
  imports: [AsyncPipe, CustomPdfViewerComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div class="card border-0 bg-transparent d-flex flex-column" style="height: 88vh;">
      <div class="card-header">
        <h5 class="card-title mb-1">Anti-Bribery and Corruption Policy</h5>
        <p class="card-text text-muted">
          Please read the anti-bribery and corruption policy and acknowledge by clicking the button at the end of the
          page.
        </p>
      </div>
      <div class="card-body p-0">
        <ad-custom-pdf-viewer
          fileName="HkAntiBriberyCorruptionPolicy.2026.1.pdf"
          (endOfDocumentReached)="isAtEndOfDocument = true"
        />
      </div>
      <div class="card-footer flex-shrink-0">
        <div class="btn-group">
          @if (alreadyAcked$ | async) {
            <button class="btn btn-primary" disabled>YOUR ALREADY ACKNOWLEDGED READING THIS DOCUMENT</button>
          } @else {
            <button class="btn btn-primary" [disabled]="!isAtEndOfDocument" (click)="acknowledge()">
              ACKNOWLEDGE AND AGREE
            </button>
          }
          <button class="btn btn-secondary" (click)="location.back()">BACK</button>
        </div>
      </div>
    </div>
  `
})
export class HkAbcPolicyAcksComponent {
  protected isAtEndOfDocument = false;
  protected alreadyAcked$: Observable<boolean> | null = null;

  private start = moment();

  constructor(
    private router: Router,
    private abcPolicyAcksService: HkAbcPolicyAcksService,
    protected location: Location
  ) {}

  ngOnInit(): void {
    this.alreadyAcked$ = this.abcPolicyAcksService.getMine$().pipe(map((item) => !!item && item.acknowledged));
  }

  public acknowledge(): void {
    this.abcPolicyAcksService
      .acknowledge$(moment.duration(moment().diff(this.start)).asMilliseconds())
      .subscribe(() => this.router.navigate(['/']));
  }
}
